import useU2000AxiosNonAuthenticated from '../../axios/U2000UseAxiosNonAuthenticated';
import { useU2000AuthContext } from '../../context/auth/U2000UseAuthContext';

const GOOGLE_EXCHANGE_URL = 'U2001/google/exchange';

type LoginResponse = any;
type MenuType = any;
type GoogleExchangeFn = (exchangeCode: string, menu: MenuType) => Promise<LoginResponse>;

/** BL-0520 — échange du code à usage unique après retour Google OIDC. */
const useU2000GoogleExchange = (): GoogleExchangeFn => {
  const { prelogin, login } = useU2000AuthContext();
  const u2000AxiosNonAuthenticated = useU2000AxiosNonAuthenticated();

  const doGoogleExchange: GoogleExchangeFn = async (exchangeCode, menu) => {
    const response = await u2000AxiosNonAuthenticated.post(
      GOOGLE_EXCHANGE_URL,
      JSON.stringify({ exchangeCode }),
    );

    let result: LoginResponse = null;
    if (
      response.data.changePasswordOnLogin ||
      (response.data.organizations && response.data.organizations.length > 1)
    ) {
      result = prelogin(response.data);
    } else {
      result = login(response.data, menu);
    }
    return result;
  };

  return doGoogleExchange;
};

export default useU2000GoogleExchange;
